import React from "react";
import Style from "style-it";
import { Field } from "redux-form";
import { connect } from "react-redux";

class MiscInput extends React.Component {
  renderMiscInput = (formProps) => {
    return (
      <React.Fragment>
        <Style>
          {`
          .dark__color::placeholder {
              color:#8C8F96
            }
          `}
        </Style>
        <div
          className={`header__filter--input--box header__filter--input--box--misc`}
        >
          <input
            autocomplete="off"
            {...formProps.input}
            placeholder="Filter by title and companies..."
            className={`header__filter--input--misc ${
              formProps.darkMode ? "dark--3 dark__color" : ""
            } `}
          />
        </div>
      </React.Fragment>
    );
  };
  render() {
    return (
      <React.Fragment>
        <Field
          name="misc"
          component={this.renderMiscInput}
          darkMode={this.props.darkMode}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    jobs: state.jobs,
    formValues: state.form,
    isLoading: state.loader.isLoading,
    darkMode: state.darkMode,
  };
};

export default connect(mapStateToProps)(MiscInput);
